import { Card } from '@mui/material';
import type { Condition } from '@repo/api-gw-sdk';

import { Loader } from '@/components/layout/loading';
import {
  getResourcesScopeType,
  type ResourcesScopeType,
} from '@/components/resourcesSelection/resourceSelectionDynamicViewer';

import { BackupScopeDynamicResourcesViewerHeader } from './components/backupScopeDynamicResourcesViewerHeader';

import { ResourcesSelectionViewer } from '../../../../../../components/resourcesSelection/resourcesSelectionViewer';

export const backupScopesResourcesAllExcludedDescription =
  'Current and future supported resources from your connected source accounts will be added to backup scope once discovered.';
export const backupScopesResourcesAllIncludedDescription =
  'Current and future resources from your connected source accounts will be excluded from backup scope once discovered.';

export const BackupScopesResources = () => {
  const conditionFromServer: Condition | undefined = undefined;
  const isLoading = false;
  const include: string[] = [];
  const exclude: string[] = [];
  const resourcesScopeType: ResourcesScopeType = conditionFromServer
    ? getResourcesScopeType(conditionFromServer)
    : 'allIncluded';
  const condition =
    resourcesScopeType === 'useConditions' ? conditionFromServer : undefined;

  return (
    <Card
      sx={{
        padding: '24px 40px',
        margin: '40px',
        minHeight: '500px',
        border: '1px solid var(--mui-palette-divider)',
      }}
    >
      {isLoading ? (
        <Loader />
      ) : (
        <ResourcesSelectionViewer
          condition={condition}
          conditionTitle='Include resources based on these conditions:'
          include={include}
          exclude={exclude}
          resourcesScopeType={resourcesScopeType}
          dynamicResourcesHeader={
            <BackupScopeDynamicResourcesViewerHeader
              resourcesScopeType={resourcesScopeType}
              condition={condition}
              include={include}
              exclude={exclude}
            />
          }
          allExcludedDescription={backupScopesResourcesAllExcludedDescription}
          allIncludedDescription={backupScopesResourcesAllIncludedDescription}
        />
      )}
    </Card>
  );
};
